// extracted by mini-css-extract-plugin
module.exports = {"answered-question":"Quizzes_answered-question__m4K-N","correct-answer":"Quizzes_correct-answer__3SziV","incorrect-answer-selected":"Quizzes_incorrect-answer-selected__171LL"};